module.exports = __webpack_public_path__ + "dingbeauty-build/img/checkout-time-out.005730dc.svg";